module.exports = __webpack_public_path__ + "img/giving-at-thanksgiving.b7ca92ed.png";